import React, { useEffect, useRef, useState } from 'react';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import CustomHit from './CustomHit';
import styled from 'styled-components';

const LoadMoreButton = styled.button`
  margin-top: 30px;
  border: 1px solid black;
  color: ${({ theme }) => theme.colors.charcoal};
  text-align: center;
  letter-spacing: 1.25px;
  line-height: 15px;
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  background: white;
  padding: 2px;
  width: 100% !important;
  height: 40px !important;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:active {
    color: ${({ theme }) => theme.colors.french};
    border: 2px solid #2a5caf;
  }

  &:focus {
    outline: 0;
  }
  @media (max-width: 600px) {
    /* font-size: 11px !important; */
    /* height: 30px !important; */
  }
`;

const Wrapper = styled.div`
  .grid-hits {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 992px) {
    .grid-hits {
      margin-top: 10px;
      grid-template-columns: 1fr 1fr;

      .custom-hit {
        display: flex;
        justify-content: center;
      }
    }
  }

  .image-container {
    padding-top: 30px;
  }
`;

function InfiniteHits(props) {
  let sentinel = useRef(null);

  const {
    hasMore,
    refine,
    refineNext,
    refinePrevious,
    hasPrevious,
    hits,
    setShowSearch,
    filters,
    searchParams
  } = props;

  return (
    <Wrapper className="ais-InfiniteHits">
      <div className="grid-hits">
        {hits.map(hit => (
          <div key={hit.objectID}>
            <CustomHit hit={hit} />
          </div>
        ))}
      </div>
      {hasPrevious && (
        <LoadMoreButton onClick={refinePrevious} disabled={!hasPrevious}>
          Show previous
        </LoadMoreButton>
      )}

      {!hasMore ? (
        'No more results'
      ) : (
        <LoadMoreButton disabled={!hasMore} onClick={refineNext}>
          Show More
        </LoadMoreButton>
      )}
    </Wrapper>
  );
}

export default connectInfiniteHits(React.memo(InfiniteHits));
